export const GENERAL = 'GENERAL';
export const SUBMISSION = 'SUBMISSION';